import { render, staticRenderFns } from "./theme.vue?vue&type=template&id=0c3c6ce2&scoped=true&"
import script from "./theme.vue?vue&type=script&lang=js&"
export * from "./theme.vue?vue&type=script&lang=js&"
import style0 from "./theme.vue?vue&type=style&index=0&id=0c3c6ce2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3c6ce2",
  null
  
)

export default component.exports